// extracted by mini-css-extract-plugin
export default {"tags":"styles-module__tags__src-labstep-web-components-Filter-Tag-Select-_VN60x"};